var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 72,
    viewBox: "0 0 87 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 0.0804654V71.9774L2.137 71.9774C1.44583 72.0118 0.890366 72.0113 0.5 71.9774H2.137C11.4791 71.5125 45.6152 64.6787 32 48C12 23.5 52.634 0.0803711 67.5 0.0804443L87 0.0804654Z",
    fill: "url(#paint0_linear_1345_30898)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1345_30898",
    x1: 0.499999,
    y1: 48.0288,
    x2: 87.2782,
    y2: 40.8528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#7A5DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletGradient);
export default __webpack_public_path__ + "static/media/wallet-gradient.fa6b8d5caaceb2c1c1b98ba45814d9e7.svg";
export { ForwardRef as ReactComponent };